import React, { PureComponent, Fragment } from "react";
import autoBind from "react-autobind";

import _ from "lodash";

import api from "./service/passwordStrength.service";

class PasswordStrength extends PureComponent {
  constructor(props) {
    super(props);
    autoBind(this);

    this.firstCall = true;

    this.state = {
      properties: {
        accepted: false,
        password: undefined,
        strength: 0,
        strengthStyle: { width: "0%" },
        strengthClass: "",
        strengthCategory: ""
      }
    };
  }

  getStrengthClass(strength) {
    let baseClass = "progress-bar bg-";

    if (strength < 30) return baseClass + "danger";
    if (strength > 75) return baseClass + "success";
    else return baseClass + "warning";
  }

  getStrengthCategory(strength) {
    const category = ["inaceitável", "muito fraca", "fraca", "média", "forte", "muito forte"];
    const index = strength / (100 / category.length) - 1;

    return category[index];
  }

  async componentDidUpdate() {
    let { password } = this.props;

    if (!password) password = "";

    const response = await api.getPasswordScore(password);
    const { data } = response;

    const strength = (data.PasswordScore + 1) * (100 / 6);
    const strengthCategory = this.getStrengthCategory(strength);

    const properties = {
      password,
      strength,
      strengthStyle: { width: strength + "%" },
      strengthClass: this.getStrengthClass(strength),
      accepted: data.ScoreValidated,
      notAcceptedMessage:
        "A senha deve possuir no mínimo cinco caracteres e atender " +
        data.MinimumScore +
        " do(s) requisito(s)" +
        " a seguir: letras e números, oito caracteres, letras maiúsculas e minúsculas, caracteres especiais.",
      tooltip: "A força da senha escolhida é " + strengthCategory.toLowerCase()
    };

    if (!_.isEqual(this.state.properties, properties)) this.setState({ properties });
  }

  render() {
    const { properties } = this.state;
    const { tooltip, strengthClass, strengthStyle, strength, accepted, notAcceptedMessage } = properties;

    return (
      <Fragment>
        <div className="password-meter progress" title={tooltip}>
          <div className={strengthClass} style={strengthStyle} aria-valuenow={strength} aria-valuemin="0" aria-valuemax="100" role="progressbar" />
        </div>
        
        {!accepted && (
          <div className="notAcceptedPassword">
            <p>{notAcceptedMessage}</p>
          </div>
        )}
      </Fragment>
    );
  }
}

export default PasswordStrength;
